module.exports = __webpack_public_path__ + "img/img-spadegaming-fish-d.d2ff1659.png";